import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion } from 'framer-motion';
import { FaUniversity, FaUserGraduate } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const PromotionCeremonyCommission = () => {
  const { t } = useTranslation();

  const committeeMembers = [
    { title: 'Prof. Dr.', name: 'Hatice Mergen', role: t('dean.title'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5582' },
    { title: 'Prof. Dr.', name: 'Canan Köroğlu', role: t('vice_deans.vice_dean'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/6842' },
    { title: 'Prof. Dr.', name: 'Barış Temelli', role: t('vice_deans.vice_dean'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5902' },
    { title: 'Dr. Öğr. Ü.', name: 'Başak Bulut Karageyik', role: t('departments.actuarial_science'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/8452' },
    { title: 'Arş. Gör.', name: 'Güven Şimşek', role: t('departments.actuarial_science'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7565' },
    { title: 'Arş. Gör. Dr.', name: 'Mustafa Asım Özalp', role: t('departments.actuarial_science'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/11284' },
    { title: 'Doç. Dr.', name: 'Esin Akbay Çetin', role: t('departments.biology'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5064' },
    { title: 'Arş. Gör. Dr.', name: 'Aygün Schiesser', role: t('departments.biology'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7411' },
    { title: 'Arş. Gör.', name: 'İlayda Gülmez', role: t('departments.biology'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/102449' },
    { title: 'Arş. Gör.', name: 'Gülşen Bayrak', role: t('departments.biology'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/102459' },
    { title: 'Doç. Dr.', name: 'Ayfer Ezgi Yılmaz Çakıroğlu', role: t('departments.statistics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7973' },
    { title: 'Arş. Gör. Dr.', name: 'Derya Turfan', role: t('departments.statistics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7404' },
    { title: 'Arş. Gör.', name: 'Dolunay Ezgi Gümüşbaş', role: t('departments.statistics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/102536' },
    { title: 'Arş. Gör.', name: 'Hatice Nur Karakavak', role: t('departments.statistics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/100217' },
    { title: 'Arş. Gör.', name: 'Serhan Tunçel', role: t('departments.statistics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/15033' },
    { title: 'Prof. Dr.', name: 'Murat Torun', role: t('departments.chemistry'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5548' },
    { title: 'Arş. Gör. Dr.', name: 'Pınar Seyitdanlıoğlu Öztürk', role: t('departments.chemistry'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/11967' },
    { title: 'Arş. Gör.', name: 'Yavuz Alagöz', role: t('departments.chemistry'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/100871' },
    { title: 'Arş. Gör.', name: 'Burcu Dilaver', role: t('departments.chemistry'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/100215' },
    { title: 'Arş. Gör.', name: 'Elif Öztürk', role: t('departments.chemistry'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/102458' },
    { title: 'Dr. Öğr. Ü.', name: 'Orhan Oğulcan Tuncer', role: t('departments.mathematics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/13197' },
    { title: 'Arş. Gör. Dr.', name: 'Zehra Şen', role: t('departments.mathematics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7620' },
    { title: 'Arş. Gör.', name: 'Egemen Çeken', role: t('departments.mathematics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/102628' },
    { title: 'Arş. Gör.', name: 'Sezer Bolat', role: t('departments.mathematics'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/100241' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 120,
      },
    },
  };

  return (
    <PageTemplate
      title={t('promotion_ceremony_commission.title')}
      subtitle={t('promotion_ceremony_commission.subtitle')}
    >
      <div className="container mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center bg-white p-8 rounded-xl shadow-lg mb-12 border-l-4 border-hacettepe-blue"
        >
          <h2 className="text-3xl font-extrabold text-gray-800 mb-4">
            {t('promotion_ceremony_commission.mission_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {t('promotion_ceremony_commission.mission_description')}
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8"
        >
          {committeeMembers.map((member, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
              className="bg-white rounded-lg shadow-md text-center p-6 transition-all duration-300 ease-in-out group"
            >
              <div className="mb-4">
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="w-28 h-28 rounded-full mx-auto object-cover border-4 border-gray-200 group-hover:border-hacettepe-blue transition-colors duration-300"
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${member.name.replace(' ', '+')}&background=1E40AF&color=fff&size=128&bold=true&rounded=true`;
                  }}
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900">{member.name}</h3>
              <p className="text-sm text-gray-500 mb-2">{member.title}</p>
              <div className="flex items-center justify-center text-gray-600 text-sm">
                <FaUniversity className="mr-2 text-hacettepe-blue" />
                <span className="font-medium">{member.role}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </PageTemplate>
  );
};

export default PromotionCeremonyCommission;